import React, { useState } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import axios from 'helpers/api';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';


const FacilityDrugInfoReport = (props) => {
    const [spinner, showSpinner] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);

    const handleSubmit = async e => {
        e.preventDefault();
        if (!props.validateFacility()) return;

        showSpinner(true);

        let tokenStr = localStorage.getItem("accessToken");
        let facilityId = props.selectedFacility || localStorage.getItem("reportFacilityId");
        let facilityDrugInfoUrl = `${process.env.REACT_APP_SERVER_URL}` + "/drugs/facility-drug-info/" + facilityId;

        try {
            const response = await axios.get(facilityDrugInfoUrl, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            if (response.data && response.data.status === false) {
                toast.error(response.data.message || "Failed to print content.");
                return;
            }
            toast.success("Facility Side Effect Sheet Generated Successfully");
            const { blobUrl } = await createIframeReportBlobUrl(response.data);
            setIframeSrc(blobUrl);
        } catch (err) {
            // axios rejects non-2xx (e.g. 400), so read the API message here
            const apiMessage = err?.response?.data?.message || err?.response?.data?.error;
            toast.error(apiMessage || "Failed to print content.");
        } finally {
            showSpinner(false);
        }
    };

    return (
        <div>
            <Form>
                <Row className="justify-content-center">
                    <Col xs={6} className="text-center">
                        {spinner ? (
                            <Button variant="primary" disabled className="mt-3 w-75 px-4 py-2">
                                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                <span className="ms-2">Loading...</span>
                            </Button>
                        ) : (
                            <Button disabled={props.selectedFacility == ''} onClick={handleSubmit} color="primary" className="mt-3 w-75 px-4 py-2">
                                Download Report
                            </Button>
                        )}
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <div style={{ height: 0, overflow: 'hidden', width: 0 }}>
                            {iframeSrc && (
                                <iframe
                                    src={iframeSrc}
                                    style={{ width: "100%", height: "400px", border: "none", borderRadius: "8px" }}
                                    title="Preview Content"
                                />
                            )}
                        </div>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} className="text-end">
                        <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

FacilityDrugInfoReport.propTypes = {
    selectedFacility: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    validateFacility: PropTypes.func.isRequired
};

FacilityDrugInfoReport.defaultProps = {
    selectedFacility: ''
};

export default FacilityDrugInfoReport;
